import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useDeleteNotification() {
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function deleteNotification(notificationId) {
    return privateFetch.delete(`/v1/admin/notification/${notificationId}`);
  }

  return useMutation(deleteNotification, {
    onSuccess() {},
    onSettled() {
      queryClient.invalidateQueries('notification-lists');
    },
  });
}

export default useDeleteNotification;
